export const MESSAGE_EASE = [0.42, 0, 0.58, 1] as const;
export const MESSAGE_ENTER_MS = 450;

export const messageEnterTransition = {
  opacity: { duration: MESSAGE_ENTER_MS / 1000, ease: MESSAGE_EASE },
  y: { duration: 0.4, ease: MESSAGE_EASE },
};

export const messageEnterInitial = {
  opacity: 0,
  y: 12,
};

export const messageEnterAnimate = {
  opacity: 1,
  y: 0,
};
